import { UseBaseMutationOptions } from '@/core/api/type'
import { useMutation } from '@tanstack/react-query'
import { RankMutationKeys } from '../../../keys'
import { UpdateRankRequest, UpdateRankResponse } from '../../../type'
import { updateRank } from '../../services'

interface UpdateRankParams {
	id: string
	payload: UpdateRankRequest
}

export default function useMutationUpdateRank(
	props?: UseBaseMutationOptions<UpdateRankResponse, UpdateRankParams>,
) {
	return useMutation({
		mutationKey: [RankMutationKeys.UpdateRank],
		mutationFn: (params) => updateRank(params.id, params.payload),
		...props,
	})
}
